import { getSearchStringMicrofrontendAPI } from '../getSearchStringMicrofrontendApi/getSearchStringMicrofrontendApi';
import { IMicrofrontendsAPI } from 'shared/types/microfrontends/types';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    getSearchStringMicrofrontendAPI: () => getSearchStringMicrofrontendAPI(),
  };
}
